import React, { useMemo, useContext } from 'react';
import { Caption2, Caption1, Body2 } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const NativeAdPreview = ({ ad, classes }) => {
  const i18n = useContext(I18nContext);
  const adTitle = useMemo(() => ad && ad.Headlines && ad.Headlines.Headline0, [ad]);
  const adDescription = useMemo(() => ad && ad.Descriptions && ad.Descriptions.Description0, [ad]);
  const businessName = useMemo(() => ad && ad.BusinessName, [ad]);
  const adImageUrl = useMemo(() => ad && ad.Images && ad.Images.ImageList && ad.Images.ImageList[0] && ad.Images.ImageList[0][0].src, [ad]);

  return (
    <>
      <div className={classes.imageContainer}>
        <img className={classes.nativeAdImage} src={adImageUrl} alt={i18n.getString(_TL_('Ad preview image'))} />
        <div className={classes.nativeAdImageForeground} />
      </div>
      <div className={classes.textOverlay}>
        <Body2>{adTitle}</Body2>
        <Caption2>{adDescription}</Caption2>
        <Caption1>
          <span className={classes.adLabel}>Ad</span>
          {businessName}
        </Caption1>
      </div>
    </>
  );
};
